function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.10154 17.4589C8.84119 17.1985 8.84119 16.7764 9.10154 16.5161L10.0443 15.5733C10.3047 15.3129 10.7268 15.3129 10.9872 15.5733L14.4535 19.0396L21.5246 11.9685C21.7849 11.7082 22.207 11.7082 22.4674 11.9685L23.4102 12.9113C23.6705 13.1717 23.6705 13.5938 23.4102 13.8542L14.9249 22.3394C14.6646 22.5998 14.2424 22.5998 13.9821 22.3394L9.10154 17.4589Z",
  fill: "white"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.3335 15.9997C1.3335 24.0998 7.89999 30.6663 16.0002 30.6663C24.1003 30.6663 30.6668 24.0998 30.6668 15.9997C30.6668 7.8995 24.1003 1.33301 16.0002 1.33301C7.89999 1.33301 1.3335 7.8995 1.3335 15.9997ZM28.0002 15.9997C28.0002 22.6271 22.6276 27.9997 16.0002 27.9997C9.37274 27.9997 4.00016 22.6271 4.00016 15.9997C4.00016 9.37226 9.37274 3.99967 16.0002 3.99967C22.6276 3.99967 28.0002 9.37226 28.0002 15.9997Z",
  fill: "white"
});
var SvgDone = function SvgDone(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/done.02609b49.svg";
export { ForwardRef as ReactComponent };